export default {
    init() {
        let scroll_buttons = document.getElementsByClassName('scroll_button');
        if(scroll_buttons.length > 0) {
            for(let i = 0; i < scroll_buttons.length; i++) {
                let scroll_button = scroll_buttons[i];
                scroll_button.addEventListener('click', (e)=>{
                    let class_name = scroll_button.value;
                    let el = this.element_exists(class_name);

                    if(el) {
                        this.scroll_to(el);
                    }
                });
            }
        }
    },
    element_exists(name) {
        let id = document.getElementById(name);
        if(id) {
            return id;
        }

        let with_class = document.getElementsByClassName(name);
        if(with_class.length > 0) {
            return with_class[0];
        }

        return undefined;
    },
    scroll_to(el) {
        // let options = {
        //     behavior: 'smooth'
        // }
        el.scrollIntoView({behavior: "smooth"});
    }
}